import { HeadingBanner } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import SiteMapItems from './SiteMapItems';

const SiteMapSections = ({ categoriesList = [] }) => (
  categoriesList.map((category) => (
    <li key={category.categoryId} className="level1Category">
      <HeadingBanner>
        {category.url ? (
          <a href={category.url}>
            <h2 className="h2">
              {category.brand && category.brand !== '??????'
                ? `${category.brand} - ${category.name}`
                : category.name}
            </h2>
          </a>
        ) : (
          <h2 className="h2">
            {category.brand && category.brand !== '??????'
              ? `${category.brand} - ${category.name}`
              : category.name}
          </h2>
        )}
      </HeadingBanner>
      <ul className="level2CategoryWrapper">
        {category.subCategories.map((item) => (
          <SiteMapItems key={item.categoryId} className="level2Category" item={item} />
        ))}
      </ul>
    </li>
  ))
);
SiteMapSections.propTypes = {
  categoriesList: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.string.isRequired,
      url: PropTypes.string,
      name: PropTypes.string.isRequired,
      brand: PropTypes.string,
      newWindow: PropTypes.bool,
      subCategories: PropTypes.arrayOf(
        PropTypes.shape({
          categoryId: PropTypes.string.isRequired,
          url: PropTypes.string,
          name: PropTypes.string.isRequired,
          newWindow: PropTypes.bool,
        }),
      ),
    }),
  ).isRequired,
};

export default SiteMapSections;
